module.exports = __webpack_public_path__ + "media/images/recruit/mv/img-mark-03-8049a184e6743d543173d71ab2593220.svg";